import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

export default function Input({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  iconPrefix: IconPrefix,
  iconSuffix: IconSuffix,
  isPasswordToggle = false,
  error,
  helperText,
  className = '',
  id,
  name,
  style,
  inputStyle,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);

  const isPasswordType = type === 'password' || isPasswordToggle;
  const actualType = isPasswordType ? (showPassword ? 'text' : 'password') : type;

  const hasPrefix = Boolean(IconPrefix);
  const hasSuffix = Boolean(IconSuffix) || isPasswordType;

  const wrapperClasses = [
    'input-wrapper',
    hasPrefix ? 'input-wrapper--has-prefix' : '',
    hasSuffix ? 'input-wrapper--has-suffix' : '',
    error ? 'error' : '',
  ].filter(Boolean).join(' ');

  const calculatedInputStyle = {
    paddingLeft: hasPrefix ? '38px' : '14px',
    paddingRight: hasSuffix ? '40px' : '14px',
    ...inputStyle,
  };

  return (
    <div className={`form-group ${className}`} style={style}>
      {label && (
        <label className="lab-medium" htmlFor={id || name}>
          {label}
        </label>
      )}
      <div className={wrapperClasses}>
        {IconPrefix && (
          <span className="input-icon-prefix">
            {typeof IconPrefix === 'function' || typeof IconPrefix === 'object' && IconPrefix.render ? (
              <IconPrefix size={18} />
            ) : (
              IconPrefix
            )}
          </span>
        )}
        <input
          id={id || name}
          name={name}
          type={actualType}
          className={`input-field ${error ? 'error' : ''}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={calculatedInputStyle}
          {...props}
        />
        {isPasswordType ? (
          <button
            type="button"
            className="toggle-password-btn input-icon-suffix"
            onClick={() => setShowPassword(!showPassword)}
            tabIndex={-1}
            title={showPassword ? 'Hide password' : 'Show password'}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--text-sub)',

            }}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        ) : IconSuffix ? (
          <span className="input-icon-suffix">
            {typeof IconSuffix === 'function' || typeof IconSuffix === 'object' && IconSuffix.render ? (
              <IconSuffix size={18} />
            ) : (
              IconSuffix
            )}
          </span>
        ) : null}
      </div>
      {error ? (
        <span className="msg caption2 error" style={{ color: 'var(--accent-red)', fontSize: '0.78rem', marginTop: '4px', display: 'block' }}>
          {error}
        </span>
      ) : helperText ? (
        <span className="caption2" style={{ color: 'var(--text-sub)', fontSize: '0.78rem', marginTop: '4px', display: 'block' }}>
          {helperText}
        </span>
      ) : null}
    </div>
  );
}
